import { useEffect, useRef, useState } from 'react';

/**
 * Shared client-side pagination.
 * @param {Array} items full list to paginate
 * @param {number} pageSize items per page
 * @param {object} opts.resetKey pass a filter/search value to jump back to page 1 when it changes
 */
const usePagination = (items, pageSize, { resetKey } = {}) => {
  const [page, setPage] = useState(1);
  const listRef = useRef(null);

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  const list = items || [];
  const totalPages = Math.max(1, Math.ceil(list.length / pageSize));
  const safePage = Math.min(page, totalPages);
  const visible = list.slice((safePage - 1) * pageSize, safePage * pageSize);

  const changePage = (next) => {
    setPage(next);
    listRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return { page: safePage, setPage, totalPages, items: visible, listRef, changePage };
};

export default usePagination;
